var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeviceLayout',[_c('PcVideoOnlyPage',_vm._b({attrs:{"slot":"pc"},slot:"pc"},'PcVideoOnlyPage',_vm.pcProps,false)),_c('MobilePage',_vm._b({attrs:{"slot":"mobile"},slot:"mobile"},'MobilePage',_vm.landingProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }